import { render, staticRenderFns } from "./operationGuide.vue?vue&type=template&id=7478a5cc&scoped=true"
import script from "./operationGuide.vue?vue&type=script&lang=js"
export * from "./operationGuide.vue?vue&type=script&lang=js"
import style0 from "./operationGuide.vue?vue&type=style&index=0&id=7478a5cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7478a5cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7478a5cc')) {
      api.createRecord('7478a5cc', component.options)
    } else {
      api.reload('7478a5cc', component.options)
    }
    module.hot.accept("./operationGuide.vue?vue&type=template&id=7478a5cc&scoped=true", function () {
      api.rerender('7478a5cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resource/operationGuide.vue"
export default component.exports